export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export type UtmKey = (typeof UTM_KEYS)[number];

export type UtmParams = Partial<Record<UtmKey, string>>;

/** Pull non-empty UTM values from a query string. Returns null if none present. */
export function extractUtmParams(
  searchParams: URLSearchParams,
): UtmParams | null {
  const result: UtmParams = {};
  let found = false;

  for (const key of UTM_KEYS) {
    const value = searchParams.get(key)?.trim();
    if (value) {
      result[key] = value;
      found = true;
    }
  }

  return found ? result : null;
}
